// extracted by mini-css-extract-plugin
module.exports = {"button":"ConnectWalletView_button__nYEtj","noMetamaskModal":"ConnectWalletView_noMetamaskModal__1VfWy","title":"ConnectWalletView_title__3fuES"};